import type { ReactNode } from "react";
import { cn } from "@racoon/ui";
import type { ReportBadgeColor } from "~/shared/utils/badgeFormatters";
import { CardContentWrapper } from "~/ui/components/cardContent.wrapper";
import { SoonBadge } from "./soon-badge";

export const MonitorStatCard = ({
  title,
  value,
  badgeLabel,
  badgeColor,
  blur = false,
}: {
  title: string;
  value: ReactNode;
  badgeLabel: string;
  badgeColor: ReportBadgeColor;
  blur?: boolean;
}) => {
  return (
    <CardContentWrapper hasDivider={false} className="flex flex-col gap-3 p-4">
      <div className="flex items-center gap-2">
        <p className="text-sm font-medium text-text-primary">{title}</p>
        {blur && <SoonBadge />}
      </div>
      {/* TODO: remove blur once feature is implemented */}
      <div className={cn("flex items-center justify-between gap-2", blur && "blur-sm")}>
        <p className="text-[22px] font-bold leading-7 tracking-tight text-text-primary">{value}</p>
        <span
          className={cn(
            "shrink-0 whitespace-nowrap rounded-full px-2 py-1 text-sm font-semibold text-white",
            badgeColor,
          )}
        >
          {badgeLabel}
        </span>
      </div>
    </CardContentWrapper>
  );
};
